<template>
<Dialog v-model:visible="show" modal header="Marka Özel Nitelikleri" :style="{ width: '95vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" @hide="hideDialog">

<div class="grid">

<div class="col-12 md:col-6 mt-4">
<span class="p-float-label">
<Dropdown v-model="selectedcustomattribute" :options="brandcustomattributes" optionLabel="name"   class="w-full  " inputId="customattribute" filter :loading="loading_attributes">
	<template #option="slotProps">
		<template v-if="slotProps.option.group">
			{{ getTheTranslation(slotProps.option,"translation") }} - <b>{{ slotProps.option.group.name }}</b>
		</template>
		<template v-else>
			{{ slotProps.option.name }}
		</template>
        
    </template>
</Dropdown>
<label for="customattribute">Özel Nitelik</label>
</span>
</div>

<div class="col-12 md:col-6 mt-4" v-if="selectedcustomattribute">
	<template v-if="selectedcustomattribute.type=='string'">
		<InputText  type="text" v-model="newitem.term" class="w-full  animate_class" placeholder="Barındırdığı terim" v-on:keyup.enter="addFilter"    />
	</template>


	<template v-if="selectedcustomattribute.type=='select' || selectedcustomattribute.type=='multiselect'">
		<span class="p-float-label">
		<MultiSelect v-model="newitem.options" :options="selectedcustomattribute.options" optionLabel="name"   class="w-full  p-inputtext-sm" inputId="customattributeoptions" filter optionValue="id" >
		<template #option="slotProps">
			{{getTheTranslation(slotProps.option,"translation")}}
		</template>		
		</MultiSelect>
		<label for="customattributeoptions">Seçenekler</label>
		</span>
	</template>


	<template v-if="selectedcustomattribute.type=='boolean'">
		<InputSwitch v-model="newitem.boolean"   />
	</template>


	<template v-if="selectedcustomattribute.type=='number'">
		<div class="grid">
			<div class="col-6">
				<span class="p-float-label">
				<InputNumber v-model="newitem.min"  inputId="minval"  :maxFractionDigits="5" class="w-full "/>
				<label for="minval">Minimum Değer</label>
				</span>
			</div>
			<div class="col-6">
				<span class="p-float-label">
				<InputNumber v-model="newitem.max"  inputId="maxval"  :maxFractionDigits="5" class="w-full "/>
				<label for="maxval">Maximum Değer</label>
				</span>
			</div>

		</div>
	</template>



</div>

<div class="col-12">
	<div class="flex align-items-center justify-content-end mt-4">
		<Button label="Filtre Ekle" class=" p-button-primary p-button-outlined  p-button-sm mr-2"  icon="pi pi-filter" @click="addFilter" ></Button>
	</div>

</div>

<div class="col-12">
<hr>
<h3 class="text-primary">Seçili Filtreler</h3>

</div>

<div class="col-12">
<DataTable 
:value="mainfilters" 
class="p-datatable-suppliers" 
dataKey="id" 
>

<Column   header="Özel Nitelik"   field="name" style="min-width: 8rem">
<template #body="slotProps">
<p @click="showMe(slotProps.data)">{{ slotProps.data.name}}</p>
</template>
</Column>

<Column   header="Tür"   field="type" style="min-width: 8rem">
<template #body="slotProps">
<template v-if="slotProps.data.type=='select'">
	<Tag 
	  class="ml-2  mb-2 custom-chip" 
	  value="Seçim" 
	  style="background-color:#352f8d"
	  /> 
</template>
<template v-if="slotProps.data.type=='multiselect'">
	<Tag 
	  class="ml-2  mb-2 custom-chip" 
	  value="Çoklu Seçim" 
	  style="background-color:#352f8d"
	  /> 
</template>

<template v-if="slotProps.data.type=='number'">
	<Tag 
	  class="ml-2  mb-2 custom-chip" 
	  value="Sayı Aralığı" 
	  style="background-color:#352f8d"
	  /> 
</template>

<template v-if="slotProps.data.type=='string'">
	<Tag 
	  class="ml-2  mb-2 custom-chip" 
	  value="Text" 
	  style="background-color:#352f8d"
	  /> 
	
</template>

<template v-if="slotProps.data.type=='boolean'">
	<Tag 
	  class="ml-2  mb-2 custom-chip" 
	  value="Açık/Kapalı" 
	  style="background-color:#352f8d"
	  /> 
	
</template>
</template>
</Column>

<Column   header="Seçim"    style="min-width: 8rem">
<template #body="slotProps">

<template v-if="slotProps.data.type=='select' || slotProps.data.type=='multiselect'">
	<Tag 
	  class="ml-2  mb-2 custom-chip" 
	  v-for="option in slotProps.data.options"
	  :value="getOptionName(option,slotProps.data.id,slotProps.data)" 
	  style="background-color:#3b82f6"
	  /> 
</template>

<template v-if="slotProps.data.type=='number'">
{{slotProps.data.min}} - {{slotProps.data.max}}
</template>

<template v-if="slotProps.data.type=='string'">
<p><b>"{{slotProps.data.term}}"</b></p>
</template>

<template v-if="slotProps.data.type=='boolean'">
	<p v-html="$filters.booleanView( slotProps.data.boolean)"></p>
</template>

</template>
</Column>

<Column   style="min-width: 8rem">
<template #body="slotProps">
<Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-1" @click="deleteFilter(slotProps.data.id)"></Button>
</template>
</Column>


</DataTable>

</div>



</div>





<template #footer>

<Button label="Filtrele" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"/>
</template>

</Dialog>
</template>

<script>
export default {

  name: 'SuppliersCustomAttributeFilter',
  props:["brand_id","filters"],
  data () {
    return {
			show:false,
			loading:true,
			loading_attributes:true,
			brandcustomattributes:[],
			selectedcustomattribute:null,
			mainfilters:[],
			newitem:{
			customattribute_id:null,
			type:null,
			options:[],
			boolean:false,
			min:null,
			max:null,
			term:"",
    	},
    }
  },
  methods:{
  	showMe(data)
  	{
  		console.log(data)
  	},
  	deleteFilter(id)
  	{
  		this.mainfilters = this.mainfilters.filter(item=>item.id !==id)
  	},
  	getOptionName(option_id,customattribute_id,data)
  	{
  		let element = this.brandcustomattributes.find(item=>item.id == customattribute_id)
  		let option = element.options.find(item=>item.id == option_id)
  		return option.name
  	},
  	async getdata()
  	{
  		this.loading = true
  		this.loading_attributes = true
  		this.brandcustomattributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.brand_id)
  		console.log(this.filters)
  		this.mainfilters = this.sanitizeArray(this.filters)
  		this.loading_attributes = false
  		this.loading = false
  	},  	
  	showDialog()
  	{  		
  		this.show = true
  		this.getdata()
  	},
  	hideDialog()
  	{  		
  		this.resetNewItem()
  		this.mainfilters = []
  		this.show = false
  	},
  	resetNewItem()
  	{
  		
  		this.selectedcustomattribute = null
  		this.newitem = {
      		customattribute_id:null,
      		type:null,
      		options:[],
      		min:null,
      		max:null,
      		term:"",
      	}
  	},
  	addFilter()
  	{
  		let obj = {
  			name:this.selectedcustomattribute.name,
  			translations:this.selectedcustomattribute.translations,
  			id:this.selectedcustomattribute.id,
  			type:this.selectedcustomattribute.type,
  			options:this.newitem.options,
  			fulloptions:this.selectedcustomattribute.options,
  			min:this.newitem.min,
  			max:this.newitem.max,
  			term:this.newitem.term,
  			boolean:this.newitem.boolean,
  		}

  		let ind = this.mainfilters.findIndex(item=>item.id == this.selectedcustomattribute.id)
  		if(ind==-1)
  		{
  			this.mainfilters.push(obj)
  		}
  		else
  		{
  			this.mainfilters[ind] = obj
  		}
  		this.resetNewItem()
  	},
  	submit()
  	{
  		this.$emit("filterSelected",this.mainfilters)
  		this.hideDialog()
  	},

  },
}
</script>

<style lang="css" scoped>
</style>